/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PersonType = 0 | 1 | 2 | 3 | 4;

export const PersonType = {
    NUMBER_0: 0 as PersonType,
    NUMBER_1: 1 as PersonType,
    NUMBER_2: 2 as PersonType,
    NUMBER_3: 3 as PersonType,
    NUMBER_4: 4 as PersonType
};

